import { render, staticRenderFns } from "./ButtonBlob.vue?vue&type=template&id=665c9c22&scoped=true&"
import script from "./ButtonBlob.vue?vue&type=script&lang=js&"
export * from "./ButtonBlob.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBlob.vue?vue&type=style&index=0&id=665c9c22&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c9c22",
  null
  
)

export default component.exports